// An assistant reply lands complete and its words sharpen in one after another.
export const REVEAL_CONFIG = {
  wordStepMs: 50,
  blockPauseMs: 160,
  durationMs: 420,
};

export const INTRO_QUESTIONS = [
  'איך לשפר את התזרים שלי?',
  'כמה הוצאתי בחצי שנה האחרונה על אוכל בחוץ?',
  'יש לי בעיה טכנית, אפשר עזרה?',
];

// During onboarding there is no cashflow to ask about yet, so the suggestions cover
// what the user is being asked to do instead.
export const ONBOARDING_INTRO_QUESTIONS = [
  'למה צריך לחבר חשבונות בנק ואשראי?',
  'משהו לא עובד לי כמו שצריך, אפשר עזרה?',
  'איך רייזאפ תשמור על המידע שלי?',
];

export const DEFAULT_ERROR_MESSAGE = 'משהו לא עבד לנו כמו שצריך, רוצה לנסות שוב?';

export const REQUEST_CONFIG = {
  url: '/api/ask-bot',
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
};

export const CHAT_POPUP_SEEN_KEY = 'riseup.chatPopupSeen';

export const CHAT_CONVERSATION_RESUME_KEY = 'riseup.chatRecentConversation';
export const CHAT_CONVERSATION_RESUME_WINDOW_MS = 60 * 1000;

export const MESSAGE_ROLES = {
  HUMAN: 'human',
  AI: 'ai',
  USER: 'user',
  // Written by a CX teammate in Intercom and relayed into this chat.
  CX: 'cx',
};

// Figma: "רותם מצוות חווית הלקוחות:" — the teammate's first name plus this.
export const CX_TEAM_LABEL = 'מצוות חווית הלקוחות:';
export const CX_ESCALATED_PLACEHOLDER = 'הודעה לצוות...';
export const CX_ESCALATION_STARTED_MESSAGE = 'השיחה עברה לצוות';
export const CX_ESCALATION_CLOSED_MESSAGE = 'השיחה עם הצוות הסתיימה. הרייזאפ צ׳אט חוזר לשיחה';
export const CX_SEND_FAILED_MESSAGE = 'ההודעה לא נשלחה לצוות. אפשר לנסות שוב.';

// Files are only useful once a person is on the other end — the assistant
// cannot read them — so the attach button appears only in an escalated thread.
export const ATTACHMENT_MAX_BYTES = 30 * 1024 * 1024;
export const ATTACHMENT_ACCEPT = 'image/png,image/jpeg,image/gif,image/webp,application/pdf,video/mp4,video/webm,video/quicktime';
export const ATTACHMENT_TOO_LARGE_MESSAGE = 'הקובץ גדול מדי. אפשר לשלוח עד 30MB.';
export const ATTACHMENT_TYPE_MESSAGE = 'אפשר לשלוח תמונה, PDF או וידאו בלבד.';
export const ATTACHMENT_TYPE_MESSAGE_NO_VIDEO = 'אפשר לשלוח תמונה או PDF בלבד.';
export const MAX_ATTACHMENTS = 3;
export const ATTACHMENT_COUNT_MESSAGE = 'אפשר לצרף עד 3 קבצים להודעה אחת.';
export const ATTACHMENT_TOTAL_MAX_BYTES = 35 * 1024 * 1024;
export const ATTACHMENT_TOTAL_TOO_LARGE_MESSAGE = 'אפשר לצרף עד 35MB בסך הכל להודעה אחת.';

// Replaces Intercom's own rating, which only the messenger could collect.
export const CSAT_TITLE_PREFIX = 'איך היתה השיחה עם';
export const CSAT_TITLE_GENERIC = 'איך היתה השיחה עם הצוות?';
export const CSAT_COMMENT_PLACEHOLDER = 'כאן אפשר לספר עוד';
export const CSAT_SCALE_LOW_LABEL = 'גרועה';
export const CSAT_SCALE_HIGH_LABEL = 'מעולה';
export const CSAT_SUBMIT_LABEL = 'לשלוח';
export const CSAT_THANKS_MESSAGE = 'תודה! המשוב עוזר לנו להשתפר.';
export const CSAT_POPUP_TITLE = 'איך היתה השיחה עם הרייזאפ צ׳אט?';
export const CSAT_POPUP_COMMENT_PLACEHOLDER = 'כאן אפשר לספר עוד...';
export const CSAT_POPUP_ERROR_MESSAGE = 'הפידבק לא נשלח, רוצה לנסות שוב?';
export const CSAT_RATING_BEST_LABEL = 'מעולה';
export const CSAT_RATING_WORST_LABEL = 'גרועה';
export const CSAT_POPUP_CONFIRMATION_MESSAGE = 'קיבלנו, תודה על הפידבק!';
export const CSAT_POPUP_CONFIRMATION_DURATION_MS = 3000;
export const CX_TOAST_ATTACHMENT_MESSAGE = 'שלחו לך קובץ';
export const CX_TOAST_DISMISS_LABEL = 'סגירה';
export const CX_TOAST_FALLBACK_MESSAGE = 'יש הודעה חדשה מהצוות';

// Asking about a conversation that ended weeks ago reads as a bug, so the card
// only appears while the conversation is still recent.
export const CSAT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
// Which conversations were already rated. Local rather than server-side: the
// score itself lives in Intercom, and this only stops the card reappearing.
export const CSAT_RATED_STORAGE_KEY = 'riseup-chat-csat-rated';
export const CSAT_RATED_MAX_ENTRIES = 50;

// Long enough to still be asked on the next app open, while the conversation is
// fresh enough for the customer to remember it.
export const AI_CSAT_PENDING_MAX_AGE_MS = 24 * 60 * 60 * 1000;
// At most one ask per customer per window, so heavy users are not surveyed
// every day. Two weeks for the first rollout; tune here.
export const AI_CSAT_COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000;
export const AI_CSAT_PENDING_STORAGE_KEY = 'riseup-chat-ai-csat-pending';
export const AI_CSAT_LAST_ASKED_STORAGE_KEY = 'riseup-chat-ai-csat-last-asked';
// Conversations already asked about, rated or dismissed alike.
export const AI_CSAT_HANDLED_STORAGE_KEY = 'riseup-chat-ai-csat-handled';
export const AI_CSAT_SOURCE = 'ai_chat';
